"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _userflow = _interopRequireDefault(require("../../styles/userflow"));

var _number = require("../../utils/number");

var headingMetaProps = {
  itemProp: 'aggregateRating',
  itemScope: true,
  itemType: 'https://schema.org/AggregateRating'
};

var HotelRatingSquare = function HotelRatingSquare(props) {
  var value = props.value,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$size = props.size,
      size = _props$size === void 0 ? 'default' : _props$size,
      _props$showMeta = props.showMeta,
      showMeta = _props$showMeta === void 0 ? false : _props$showMeta,
      count = props.count;
  if (!value) return null;
  var ratingMetaProps = showMeta ? headingMetaProps : {};

  var aggregatedRatingAttributes = function aggregatedRatingAttributes(countParams) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("meta", {
      itemProp: "worstRating",
      content: "1"
    }), /*#__PURE__*/_react["default"].createElement("meta", {
      itemProp: "bestRating",
      content: "10"
    }), /*#__PURE__*/_react["default"].createElement("meta", {
      itemProp: "ratingCount",
      content: countParams
    }));
  };

  var formattedRating = (0, _number.toDecimalString)(value, 1);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    _react["default"].createElement("div", ratingMetaProps, showMeta && count ? aggregatedRatingAttributes(count) : null, /*#__PURE__*/_react["default"].createElement(StyledRating, {
      value: value,
      className: className,
      $size: size
    }, formattedRating))
  );
};

var getRatingStyle = function getRatingStyle(value) {
  if (value >= 8.5) {
    return "\n      color: ".concat(_userflow["default"].colors.white, ";\n      background: #00BC4B;\n    ");
  }

  if (value >= 7) {
    return "\n      color: ".concat(_userflow["default"].colors.white, ";\n      background: #6AC140;\n    ");
  }

  return "\n    background: #888C93;\n    color: ".concat(_userflow["default"].colors.white, ";\n  ");
};

var StyledRating = _styledComponents["default"].div.withConfig({
  displayName: "HotelRatingSquare__StyledRating",
  componentId: "sc-16u8alm-0"
})(["display:flex;justify-content:center;align-items:center;width:", "px;height:", "px;font-weight:bold;font-size:", "px;", ";border-radius:5px;"], function (_ref) {
  var $size = _ref.$size;
  return $size === 'default' ? '48' : '32';
}, function (_ref2) {
  var $size = _ref2.$size;
  return $size === 'default' ? '32' : '24';
}, function (_ref3) {
  var $size = _ref3.$size;
  return $size === 'default' ? '20' : '15';
}, function (_ref4) {
  var value = _ref4.value;
  return getRatingStyle(value);
});

var _default = HotelRatingSquare;
exports["default"] = _default;